<template> 
    <button class="btn btn-flex btn-secondary px-6 position-relative me-5 btn-flex-full border border-danger  border-dashed" btn-set-rota data-bs-toggle="modal" :data-bs-target="'#' + modal "  @click="gerarBoletim" >  
        <span class="menu-icon">
            <i class="fas fa-database fa-2x bi fs-2x text-danger" ></i> 
        </span>
        <span class="d-flex flex-column align-items-start ms-2">
            <span class="fs-3 fw-bolder">Gerar</span>
            <span class="fs-7">Certificado</span>
        </span>
        <span class="position-absolute top-0 start-90 translate-middle  badge  badge-danger">Pdf</span>
    </button> 
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true"  >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content"  style="min-height: 450px;">  
                <div class="modal-header"> 
					<h2>Certificado</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y " :key="identificador" >
                    <CardRh >  
                        <div class="col-12 col-md-12  min-h-1850px"> 
                            <iframe :src="url" width="100%" height="700px"   style="border: none;"></iframe>   
                        </div>   
                    </CardRh> 
				</div>   
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts">  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    @Options({
        name: "HistoricoPdf",
        components: {  CardRh  },   
    }) 
    export default class HistoricoPdf extends Vue { 
        
        @Prop( ) readonly matricula!: any  
        @Prop( ) readonly service!: any  
        @Prop( ) readonly token!: any  
        
        public identificador = 1 ;   
        public url: any = "";
        public modal: any = "modal_matricula_certificado";

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
  
        public gerarBoletim(){
            this.url =   null;  
            setTimeout(() => {
                this.url = this.service.getApiUrlCertificado() + '/matricula/' + this.matricula + '/gerar/certificado' + '?token=' + this.token ;;
                this.identificador++;
            }, 2 ); 
        }
    } 
</script>


<style scoped>  
    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    } 

    .start-90{
        left: 97% !important;
    }
</style>